module.exports = __webpack_public_path__ + "img/ic_32_workout_high-active.fa875e72.svg";